import Box from '@mui/joy/Box'
import Typography from '@mui/joy/Typography'

export const ItemProgress = ({ items }) => {
    const scheduled = Object.keys(items).filter((key) => {
        return items[key].postData !== null
    })
    const total = Object.keys(items).length
    return (
        <Box sx={{ p: 2 }}>
            <Typography color="neutral" level="h5">
                {scheduled.length}/{total} Completed
            </Typography>
        </Box>
    )
}
